export default "/fonts/vendor/mdui/dist/roboto/Roboto-Light.woff?8dc942c71385e7509b87af5d07f3db78";